import React from 'react';
import * as S from './MenuIndicator.styles';
export let MenuIndicatorKind = /*#__PURE__*/function (MenuIndicatorKind) {
  MenuIndicatorKind["Error"] = "ERROR";
  MenuIndicatorKind["Warning"] = "WARNING";
  return MenuIndicatorKind;
}({});
export const MenuIndicator = ({
  children,
  count,
  kind
}) => count === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(S.Wrapper, null, children, /*#__PURE__*/React.createElement(S.Indicator, {
  kind: kind
}, count));